<template>
    <div class="row">
        <div class="col-12 mb-1">
            <div class="bg-light p-75 rounded">
                <h2 class="font-weight-bolder">{{$safe(value,'Clause')}}</h2>
                <p class="mb-0">{{$safe(value,'Description')}}</p>
            </div>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ceza Tutarı (TL)</label>
            <v-currency-input input-class="text-right" :value="value.Price" v-on:update-value="v => value.Price = v"></v-currency-input>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-date-picker type="date" placeholder="Geçerlilik Başlangıç Tarihi" v-model="value.StartDate"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bitiş Tarihi</label>
            <v-date-picker type="date" placeholder="Geçerlilik Bitiş Tarihi" v-model="value.EndDate"></v-date-picker>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.IsCanChangablePrice">Değiştirilebilir</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    components:{
        VCurrencyInput,
        BFormCheckbox
    },
    props:{
        value:Object
    }
}
</script>

<style>

</style>